import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

export function useAutoFavoriteFromQueryParam({
  enabled,
  toggle,
  templateIds,
  onSuccess,
}: {
  enabled: boolean;
  toggle: (id: string, opts?: { onSuccess?: () => void }) => void;
  templateIds?: string[];
  onSuccess?: () => void;
}) {
  const router = useRouter();
  const triggered = useRef(false);
  const addToFavoritesId = router.query.addToFavorites as string | undefined;
  const isMatch = templateIds
    ? Boolean(addToFavoritesId && templateIds.includes(addToFavoritesId))
    : true;

  useEffect(() => {
    if (triggered.current || !enabled || !addToFavoritesId || !isMatch) return;
    triggered.current = true;
    toggle(addToFavoritesId, {
      onSuccess: () => {
        const { addToFavorites: _, ...restQuery } = router.query;
        router.replace(
          { pathname: router.pathname, query: restQuery },
          undefined,
          { shallow: true },
        );
        onSuccess?.();
      },
    });
  }, [enabled, addToFavoritesId, isMatch]);
}
